import React from "react";
import { Icon } from "semantic-ui-react";

const WhatsAppFloatingButton = ({numero, mensaje}) => {
     if(numero=="")
         return "";
  return (
    <a
      href={"https://wa.me/"+numero+"?text="+mensaje}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#25D366",
        color: "white",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "30px",
        zIndex: 1000,
      }}
    >
      <Icon name="whatsapp" />
    </a>
  );
};

export default WhatsAppFloatingButton;
